module.exports = __webpack_public_path__ + "static/img/mpt-gov-by-banner-spisok-em-rb_1.ebb4cdf2.jpg";